import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import clsx from 'clsx';
import type { CICaseDetail } from 'components/CriticalIncident/interfaces';
import { useDialogShadow } from 'hooks/useDialogShadow';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CICaseSummarySidePanel } from '../CICaseSummarySidePanel/CICaseSummarySidePanel';
import { Button } from 'components/Shared/Inputs';

import './CICaseSummaryModal.scss';

interface CICaseSummaryModalProps {
    open: boolean;
    handleClose: () => void;
    ciCase: CICaseDetail;
}

export const CICaseSummaryModal: FC<CICaseSummaryModalProps> = (props) => {
    const { open, ciCase, handleClose } = props;
    const { t } = useTranslation('criticalIncident', { useSuspense: false });
    const { modalRef, headerRef, footerRef, topShadowTriggerRef, bottomShadowTriggerRef, isHeaderIntersecting, isFooterIntersecting } = useDialogShadow();

    return (
        <Modal open={open} ref={modalRef} onClose={handleClose} className='dialog_wrapper ci_referral_decision_dialog ci_case_summary_dialog' role="dialog" aria-modal>
            <div className="dialog_surface">
                <div ref={headerRef} className={clsx('dialog_title_wrapper', { 'top-shadow': !isHeaderIntersecting })}>
                    <h1 id="ci_case_summary_dialog_title">
                      {t('summary')}
                    </h1>
                    <IconButton aria-label={t('close')} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="dialog_content_wrapper">
                    <div ref={topShadowTriggerRef} className="shadow-trigger top" />
                    <CICaseSummarySidePanel ciCase={ciCase} isModal={true} />
                    <div ref={bottomShadowTriggerRef} className="shadow-trigger bottom" />
                </div>
                <div ref={footerRef} className={clsx('dialog_actions_wrapper', { 'bottom-shadow': !isFooterIntersecting })}>
                  <Button variant='text' onClick={handleClose}>{t('close')}</Button>
                </div>
            </div>
        </Modal>
    );
};
